import { render } from "./Paginacio.vue?vue&type=template&id=9d02b952"
import script from "./Paginacio.vue?vue&type=script&lang=js"
export * from "./Paginacio.vue?vue&type=script&lang=js"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__